import {inject} from '@angular/core';
import {ColorSchemaService} from './color-schema.service';
import {IColorSchema} from './color-schema.model';

export {
  COLOR_SCHEME,
  ColorSchemeName,
  createColorSchema,
  IColorSchema,
} from './color-schema.model';

/**
 * Method: Capture the colour schema once, in an injection context, so templates bind plain fields
 */
export function injectColorSchema(): IColorSchema {
  return inject(ColorSchemaService).getColorSchema();
}
